import { render, staticRenderFns } from "./iconCash.vue?vue&type=template&id=5cb143f2&scoped=true"
import script from "./iconCash.vue?vue&type=script&lang=js"
export * from "./iconCash.vue?vue&type=script&lang=js"
import style0 from "./iconCash.vue?vue&type=style&index=0&id=5cb143f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb143f2",
  null
  
)

export default component.exports